import { FC } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { useHighflyerStateSlice } from '../../../../store/slices/highflyerState/selectors';
import { SingleMultiplier } from '../../../tableSheet/singleMultiplier/SingleMultiplier';

import { CashedBets } from './CashedBets';
import { TotalBets } from './TotalBets';

import styles from './CashedAndTotalBets.module.css';

interface CashedBetsProps {
  show: boolean;
  showStaticData: { static: boolean; previous: boolean };
}

export const CashedAndTotalBets: FC<CashedBetsProps> = ({ show, showStaticData }) => {
  const mul = useHighflyerStateSlice.getMultiplier();

  const leaderBoardHistory = useHighflyerGameStateSlice.leaderBoardHistory();
  const lastGameData = useHighflyerGameStateSlice.lastGameData();

  const _show = showStaticData.static ? true : show;
  const _mul = showStaticData.static ? true : mul;
  const _betCount = _show ? leaderBoardHistory?.betCount : lastGameData?.totalBetCount;
  const _cashedAmount = _show ? leaderBoardHistory?.cashedAmount : lastGameData?.totalCashedAmount;
  const _cashedBetCount = _show ? leaderBoardHistory?.cashedBetCount : lastGameData?.totalCashedBetCount;

  const mods = useModifiers(styles, 'cashedAndTotalBets_previous', {
    container: !_show || showStaticData.previous,
    static: showStaticData.static,
    staticprevious: showStaticData.previous,
  });

  return (
    <div className={`${styles.cashedAndTotalBets_container} ${mods}`}>
      {!_show && (
        <div className={styles.cashedAndTotalBets_multiplier}>
          <SingleMultiplier value={Number(lastGameData?.multiplier)} />
        </div>
      )}
      {showStaticData.previous && (
        <div className={styles.cashedAndTotalBets_multiplier}>
          <SingleMultiplier value={Number(5.01)} />
        </div>
      )}
      <div className={styles.cashedAndTotalBets_inner_container}>
        {_mul || !_show ? (
          <CashedBets
            betCount={showStaticData.static ? 2501 : _betCount}
            cashedAmount={showStaticData.static ? 10000 : _cashedAmount}
            cashedBetCount={showStaticData.static ? 200 : _cashedBetCount}
            showStaticData={showStaticData.static}
          />
        ) : (
          <TotalBets betCount={leaderBoardHistory?.betCount} betAmount={leaderBoardHistory?.betAmount} />
        )}
      </div>
    </div>
  );
};
